import { Button } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { FiFilter } from 'react-icons/fi'

export const FilterButton = () => {
  const { t } = useTranslation()
  return (
    <Button
      color='white'
      variant='outlined'
      className='flex items-center gap-3'
    >
      <FiFilter size='1rem' />
      {t('filters.other')}
    </Button>
  )
}
